import React from "react";
import { useHistory } from "react-router-dom";
import { useFlash } from "./FlashContext";

function isValidReminderDays(days: number) {
  return Number.isInteger(days) && days >= 1 && days <= 7;
}

function storageKeyForUser(userId: number) {
  return `passwordExpirationToastNonce:${userId}`;
}

interface Props {
  userId: number;
  password_expiration_reminder_days: number | null | undefined;
  password_expiration_reminder_nonce: string | null | undefined;
}

const PasswordExpirationToast: React.FC<Props> = ({
  userId,
  password_expiration_reminder_days,
  password_expiration_reminder_nonce,
}) => {
  const { showToast } = useFlash();
  const history = useHistory();

  React.useEffect(() => {
    let days: number | null = null;
    if (password_expiration_reminder_days != null) {
      days = Number(password_expiration_reminder_days);
    }
    const nonce =
      password_expiration_reminder_nonce != null
        ? String(password_expiration_reminder_nonce).trim()
        : "";

    if (
      days == null ||
      !isValidReminderDays(days) ||
      !nonce ||
      !userId
    ) {
      return;
    }

    try {
      if (
        typeof sessionStorage !== "undefined" &&
        sessionStorage.getItem(storageKeyForUser(userId)) === nonce
      ) {
        return;
      }
    } catch {
      // ignore
    }

    const bodyText =
      days === 1
        ? "Your password will expire in 1 day."
        : `Your password will expire in ${days} days.`;

    showToast({
      type: "password_expiration",
      title: "Password Expiration",
      text: bodyText,
      autoHideDuration: null,
      actionLink: {
        label: "Update password",
        onClick: () => {
          history.push("/profile-edit", { openPasswordSection: true });
        },
      },
    });

    try {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.setItem(storageKeyForUser(userId), nonce);
      }
    } catch {
      // ignore
    }
  }, [
    userId,
    password_expiration_reminder_days,
    password_expiration_reminder_nonce,
    showToast,
    history,
  ]);

  return null;
};

export default PasswordExpirationToast;
